module.exports = __webpack_public_path__ + "media/img/events/location/bus-6a242620949f6b8b860d1ea094d9e5f7.svg";